import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { AnswerSubCategoryDetail } from "@/schema/console/checking-assessments/AnswerSubCategoryDetail";
import { useId } from "react";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface AnswerRadioGroupProps {
  index: number;
}

function AnswerRadioGroup({ index }: AnswerRadioGroupProps) {
  const id = useId();
  const { control } = useFormContext<AnswerSubCategoryDetail>();
  const {
    field: { value },
  } = useController({ control, name: `answer_contents.${index}.answer` });
  const { t } = useTranslation();
  return (
    <RadioGroup
      className="inline-flex gap-12"
      value={value.toString()}
      disabled={true}
    >
      <label htmlFor={`${id} 0`} className="inline-flex items-center gap-2">
        <RadioGroupItem value="1" id={`${id} 0`} />
        <span>{t("yes")}</span>
      </label>
      <label htmlFor={`${id} 1`} className="inline-flex items-center gap-2">
        <RadioGroupItem value="2" id={`${id} 1`} />
        <span>{t("no")}</span>
      </label>
      <label htmlFor={`${id} 2`} className="inline-flex items-center gap-2">
        <RadioGroupItem value="3" id={`${id} 2`} />
        <span>{t("not-applicable")}</span>
      </label>
    </RadioGroup>
  );
}

export default AnswerRadioGroup;
